import React from 'react';

export default class Page6 extends React.Component {

    _savePageStatus = (nextPage) => () => {

        this.props.handleChangeMainPage(nextPage)();

        if (this.props.incompletePage)
            this.props.savePageStatus()('HowToEngageOthersToDeliver');
    }

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="circle_title-first"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>NEXT STEPS
                                            </div>
                                            <p>Here are some practical suggestions that may help to improve your
                                                ability to engage others
                                                to deliver:</p>
                                            <div className="border_subtitle">Use the grid template with your
                                                team
                                            </div>
                                            <p>Use the template to record observations and conversations
                                                regarding team member characteristics.
                                                Use the data recorded in the template to delegate tasks. Having
                                                delegated tasks set SMART
                                                goals and realistic deadlines. Agree plans with each team
                                                member. Monitor progress against the
                                                agreed action plans and review on a regular basis.</p>
                                            <div className="border_subtitle">Use the exercises in this tool
                                            </div>
                                            <p>Use the process described in this tool to uncover and explore the
                                                individual characteristics of
                                                your team members and how they affect the ability of each to
                                                deliver.</p>
                                            <div className="border_subtitle">Write a development plan</div>
                                            <p>Make ‘engaging others to deliver’ part of your personal
                                                development plan, or create one using
                                                this topic as a starting point. Ensure you clarify your
                                                objectives and give yourself practical things
                                                to do to make real progress.</p>
                                            <div className="border_subtitle">Gain feedback</div>
                                            <p>Ask for comments from your team about how they perceive you.
                                                Encourage them to be honest
                                                – assure confidentiality, if necessary – to get a realistic and
                                                objective overview.</p>

                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>Further Information
                                            </div>
                                            <div className="uiheading"><p>If you found this tool useful then you
                                                are likely to find the following tools both insightful and
                                                relevant:</p></div>
                                            <div className="keyquestionpad">
                                                <ul className="greenbullet-list sept">
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToDirectPeople')}
                                                        className="link_color task button-link-redirect">How to direct people</div>
                                                    </li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToMotivateOthers')}
                                                        className="link_color task button-link-redirect">How to motivate others</div>
                                                    </li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToInfluenceOthers')}
                                                        className="link_color task button-link-redirect">How to influence others</div>
                                                    </li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToGainBuyInAndCommitment')}
                                                        className="link_color task button-link-redirect">How to gain buy-in and
                                                        commitment</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToMakeReasonedJudgements')}
                                                        className="link_color task button-link-redirect">How to make reasoned
                                                        judgements</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToDeliverEveryTime')}
                                                        className="link_color task button-link-redirect">How to deliver every
                                                        time</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToMaintainMomentum')}
                                                        className="link_color task button-link-redirect">How to maintain momentum</div>
                                                    </li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToDelegate')}
                                                        className="link_color task button-link-redirect">How to delegate</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToUseOptimismToAchieve')}
                                                        className="link_color task button-link-redirect">How to use optimism to
                                                        achieve.</div></li>


                                                </ul>
                                            </div>
                                            <div className="circle_title "><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>REFERENCES
                                            </div>

                                            <ol className="testclass">
                                                <li><p className="further_info_content">Lewin, K., Lippit,
                                                    R. &amp; White, R. (1939). Patterns of aggressive behavior
                                                    in experimentally created social
                                                    climates.
                                                    <span
                                                        className="subtiltereg">Journal of Social Psychology,</span> 10,
                                                    271-301.</p></li>
                                                <li><p className="further_info_content">van Dierendonck,
                                                    D., &amp; Groen, R. (2011). Belbin revisited: A
                                                    multitrait–multimethod investigation of a team
                                                    role instrument.
                                                    <span className="subtiltereg">European Journal of Work and Organizational Psychology,	</span> 20(3),
                                                    345-366.</p></li>
                                                <li><p className="further_info_content">Adapted from Buckingham,
                                                    M., &amp; Clifton, D. (2001). <span className="subtiltereg">Now Discover your Strengths: How to Develop Your
Talents and Those of the People You Manage.</span> London: Pocket Books.
                                                </p></li>


                                            </ol>


                                            <div className="left-btn">
                                                <div onClick={this.props.handleChangePage('Page5')}
                                                     className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this._savePageStatus('Task')}
                                                    className="button-next-previous-done task">Done
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}